import { useTranslation } from "react-i18next"
import vconst from "utils/helpers/structs/vconst";
import { useModal } from "context/ModalContext";
import { getButtonsNoYes } from "context/helpers/helperModalContext";
import { Formik } from "formik";
import { useRef } from "react";
import { Form } from "react-bootstrap";
import { DateTime as DT } from "luxon";
import { safeFloatParse } from "utils/helpers/safeParsing";
 
const useStatusObject = () => {

    const { t } = useTranslation(['Objects']);
    const { showDlg } = useModal();
    const refForm = useRef();

    const paramsDelDlg = {
        buttons : [...getButtonsNoYes(t)], 
        type    : 'confirm',
    } 

    const createParams = (type, title, description, objectStatus, cbFunct) => {
        const p = {
            ...paramsDelDlg,
            text: (<>
                <h4 className={`d-flex border-bottom pb-2 mb-2 text-${type}`}>
                <span className="">{title}?</span></h4>
                <span className="">{description}</span> 
            </>)
        }
        p.buttons[1].handleClick = () => {  
            showDlg(false);
            cbFunct({status:objectStatus});
        }

        return p;
    }
 
      
    const statusObjectFinished = (cbFunct, defValue) =>{
        const today = DT.now().setZone('local').toISODate();

        const p = {
            ...paramsDelDlg,
            text: (<>
                <h4 className={`d-flex border-bottom pb-2 mb-2 text-body`}>
                <span className="">{t('toolObjectFinished')}?</span></h4>
                <span className="mb-3 d-block">{t('infoObjectFinished')}</span> 
                <Formik initialValues={{
                    power: defValue || 0,
                    finishConfirm: false,
                    finishedDate: today,
                }}
                onSubmit={(values) => {
                    if (!values.finishConfirm) return;
                    const finished = DT.fromISO(values.finishedDate, { zone: 'local' }).toMillis();
                    if (!finished) return;
                    showDlg(false);
                    cbFunct({
                        power: safeFloatParse(values.power),
                        status: vconst.objectFinished,
                        finished,
                    });
                }}>

                {({handleSubmit, setFieldValue, values}) => ( 
                <form ref={refForm}
                    onSubmit={handleSubmit}>

                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="inputCloseDate" className="text-muted">
                            {t('labelCloseDate')}
                        </Form.Label>
                        <Form.Control
                            id="inputCloseDate"
                            type="date"
                            required
                            value={values.finishedDate}
                            onChange={(e) => setFieldValue('finishedDate', e.target.value)}
                        />
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Check
                            type="switch"
                            id="inputFinishConfirm"
                            required
                            checked={values.finishConfirm}
                            onChange={(e) => setFieldValue('finishConfirm', e.target.checked)}
                            label={t('labelFinishConfirm')}
                        />
                        <Form.Text className="text-muted d-block mt-1">
                            {t('descFinishConfirm')}
                        </Form.Text>
                    </Form.Group>
                </form>)}
                </Formik>
            </>),
            idFirstFocus: 'inputCloseDate'

        }
        p.buttons[1].handleClick = (e) => {  
            e.preventDefault();
            if (refForm.current?.reportValidity()) {
                refForm.current?.requestSubmit?.();  
            }
        }
        
        showDlg(p)
        
    }

    const statusObjectReject = (cbFunct) => { 
        const p = createParams('danger ',
                t('toolObjectCancel'),
                t('infoObjectCancel'),
                vconst.objectReject, cbFunct);
        showDlg(p)
    }

    const statusObjectOpen = (cbFunct) => {
        const p = createParams('body ',
                t('toolObjectOpen'),
                t('infoObjectOpen'),
                vconst.objectPanding, cbFunct);
        showDlg(p)
    }

    const statusObjectInWork = (cbFunct) => {
        const p = createParams('body ',
                t('toolObjectInWork'),
                t('infoObjectInWork'),
                vconst.objectInWork, cbFunct);  
        showDlg(p)                 
    }

    const statusObjectReturnToTeam = (cbFunct) => {
        const p = createParams('body ',
                t('toolObjectReturnToTeam'),
                t('infoObjectReturnToTeam'),
                vconst.objectInWork, cbFunct);
        showDlg(p)
    }
 
    const statusObjectFinishedTeam = (cbFunct) => {
        const p = createParams('success ',
                t('toolObjectFinishedTeam'),
                t('infoObjectFinishedTeam'),
                vconst.objectFinishedTeam, cbFunct);  
        showDlg(p) 
    }    

    return {
        statusObjectFinished,
        statusObjectReject,
        statusObjectOpen,
        statusObjectInWork,
        statusObjectReturnToTeam,
        statusObjectFinishedTeam
    }
}

export default useStatusObject;
